<template>
  <app-data-editor
    :id="id"
    title="Редактирование Экспедитора"
    resource="forwarders"
    :elements="elements"
    add-message="Экспедитор добавлен"
    edit-message="Экспедитор изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v =>
                  v.length >= 3 ||
                  "Наименование должно содержать не менее 3-х символов",
              ],
            },
            default: "",
          },
          {
            title: "Адрес",
            name: "address",
            control: {
              type: "text",
            },
            default: "",
          },
          {
            title: "Контактная информация",
            name: "contactInfo",
            control: {
              type: "text",
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
